import { Modal, Button, Box, Grid } from "@mui/material";
import { H5 } from "./Typography";
type MyModalProps = {
  open: boolean;
  handleClose: () => void;
  handleSave: () => void;
  otp: string;
};

function KycOTPModel({ open, handleClose, handleSave, otp }: MyModalProps) {
  const handleSaveClick = () => {
    handleSave();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid sx={style}>
        <Box sx={header}>
          <H5
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              p: 1.5,
              color: "#ffff",
            }}
            fontWeight={"500"}
          >
            OTP
          </H5>
        </Box>
        <Grid container sx={{ mt: 2 }} spacing={2}></Grid>
        <Box sx={container}>
          <H5
            fontSize={20}
            fontWeight={700}
            sx={{ color: "#000000", fontFamily: "'Poppins', sans-serif" }}
          >
            OTP- {otp}
          </H5>
          <H5
            fontWeight={400}
            sx={{
              color: "#595959",
              mt: 1,
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            The investor has to speak each letter of this OTP {otp} clearly in
            the video. This is used to verify that the video is not a
            pre-recorded one. (The audio has to be loud and clear otherwise the
            request will be rejected. Also the video size should not be more
            than 10 MB)
          </H5>

          <Box sx={buttonContainer}>
            <Button variant="contained" onClick={handleSaveClick} sx={add}>
              Proceed
            </Button>
          </Box>
        </Box>
      </Grid>
    </Modal>
  );
}

export default KycOTPModel;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",

  boxShadow: 4,

  borderRadius: 2,
  overflow: "hidden",
};
const header = {
  width: 400,
  bgcolor: process.env.REACT_APP_PRIMARY_COLOR,

  boxShadow: 4,
};
const container = {
  pl: 2,
  pr: 2,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  pb: 1.5,
  pt: 2,
};

const buttonContainer = {
  width: "90%",
  justifyContent: "center",
  flexDirection: "row",
  display: "flex",
  p: 1,
  mt: 1.5,
};

const add = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "80%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
